export default "__VITE_ASSET__CWB1s7Oy__"